import { createAction } from '@reduxjs/toolkit';

import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const emailMisspelledModalSetIsModalOpen = createAction(
    'EMAIL_MISSPELLED_MODAL::SET_IS_MODAL_OPEN',
);

const useEmailMisspelledModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();

    return {
        isModalOpen,
        setIsModalOpen,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useEmailMisspelledModal();

        useActionObservableCallback(
            hookAction$,
            emailMisspelledModalSetIsModalOpen().type,
            (value) => hook.setIsModalOpen(value),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [EmailMisspelledModalProvider, useEmailMisspelledModalContext] =
    createContextProvider(providerFactory);
